import apiClient from '@shared/api'
import dcmApiClient from '@/shared/api/dcm/dcmApiClient'
import { installRequestInterceptor } from '@shared/utils/interceptors/requestInterceptor'
import { installResponseInterceptor } from '@internal/interceptors/responseInterceptor'
import type { IRouteContext } from '@shared/types/route-context'
import authorization from '@shared/utils/authorization'
import type { CognitoUserSession } from 'amazon-cognito-identity-js'

export const unknown = async ({ next }: IRouteContext) => {
  const session: CognitoUserSession | null = await authorization.loadPersisted()
  const customToken = localStorage.getItem('customToken') || null
  const sessionToken: string | null = session ? session.getAccessToken().getJwtToken() : customToken
  if (sessionToken) {
    installRequestInterceptor({ apiClient, sessionToken })
    installRequestInterceptor({ apiClient: dcmApiClient, sessionToken })
  }

  installResponseInterceptor({
    apiClient,
  })
  installResponseInterceptor({ apiClient: dcmApiClient })

  return next()
}
